// // import React from 'react';
// // import ReactDOM from 'react-dom/client';
// // import './index.css';
// // import App from './App';
// // import reportWebVitals from './reportWebVitals';
// // import { MsalProvider } from '@azure/msal-react';
// // import { msalInstance } from './authConfig';

// // const root = ReactDOM.createRoot(document.getElementById('root'));
// // root.render(
// //   <React.StrictMode>
// //     <MsalProvider instance={msalInstance}>
// //     <App />
// //     </MsalProvider>
// //   </React.StrictMode>
// // );

// // // If you want to start measuring performance in your app, pass a function
// // // to log results (for example: reportWebVitals(console.log))
// // // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();

// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';

// // Import CSS baseline for consistent styling across browsers
// import './index.css';

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
import { createRoot } from "react-dom/client";
import App from "./App";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";

LicenseManager.setLicenseKey(
 "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-074784}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{iD_Fresh_Food(India)_Pvt_Ltd}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Month_Planner}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Month_Planner}_need_to_be_licensed___{Month_Planner}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{9_February_2026}____[v3]_[0102]_MTc3MDU5NTIwMDAwMA==d677a624a878c10d4ebbd520415797aa"
);
//"[TRIAL]_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-067942}_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_purchasing_a_production_key_please_contact_info@ag-grid.com___You_are_granted_a_{Single_Application}_Developer_License_for_one_application_only___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_{15 November 2024}____[v3]_[0102]_MTczMTYyODgwMDAwMA==0f38fbd34b7ae4abb7c4e7ab5499fcc2"

// Get the root element
const rootElement = document.getElementById("root");

// Create a root and render the app
const root = createRoot(rootElement);
root.render(<App />);